export const LOAD_CART_REQUEST = 'LOAD_CART_REQUEST';
export const LOAD_CART_SUCCESS = 'LOAD_CART_SUCCESS';
export const LOAD_CART_FAILURE = 'LOAD_CART_FAILURE';

export const UPDATE_CART_REQUEST = 'UPDATE_CART_REQUEST';
export const UPDATE_CART_SUCCESS = 'UPDATE_CART_SUCCESS';
export const UPDATE_CART_FAILURE = 'UPDATE_CART_FAILURE';

export const UPDATE_CART_MONOGRAM = 'UPDATE_CART_MONOGRAM';
